import React from 'react';
import {usePages, useNeuroState} from "@ignitesales/neuro-application";
import ReactSVG from "react-svg";
import {useBreakpoints} from "@ignitesales/neuro-application/src/neuro-ui/index.mjs";


const ProgressBar = () => {
  const componentClass = 'progressBar';
  const { bankSelected } = useNeuroState();
  
  const { progress } = usePages();

  const { total } = progress;
  
  
  const progressValue = Math.round(total);

  const { md } = useBreakpoints();
  const isMobile = !md;

  const totalPagesMobileProgress = 10
  const currentPageMobileDerived = Math.round(total / totalPagesMobileProgress);

  return <div className={componentClass} role="progressbar" aria-valuenow={progress.total || 1} aria-valuemin="0" aria-valuemax="100">
      <div className={`${componentClass}__outer ${bankSelected}`}>
        {isMobile 
          ? <>
          {
            Array(totalPagesMobileProgress).fill(null).map((v, index) => {
              const isCurrentClass = index + 1 === currentPageMobileDerived ? 'current' : '';
              const isActiveClass = index + 1 < currentPageMobileDerived ? 'active' : '';
              return (<div key={index+v} className={`${componentClass}__mobile-page ${isCurrentClass} ${isActiveClass}`}></div>)
            })
          }
          </>
          : <>
        {bankSelected !== 'jefferson' ?
          <ReactSVG 
            className={`${componentClass}__logo`} 
            style={{left: `calc(${progressValue}% - 13px)`}} 
            src='/classpath/assets/images/central-logo-icon-green.svg'
          />
          : null
        }
        <div className={`${componentClass}__inner`} style={{width: `${progressValue}%`}}></div>
      </> 
        }
        
      </div>


  </div>;
};

export default ProgressBar;
